import { Columns } from '@domain-group/suit-theme'

import useArtworkTemplateGroup from '@hooks/useArtworkTemplateGroup'

import PageLayout from '../../../../components/PageLayout'

import ArtworkTemplateGroupLinkLists from '../ArtworkTemplateGroupLinkLists'

interface PageContentProps {
  artworkTemplateGroupId: number,
}

const PageContent = (props: PageContentProps) => {
  const { artworkTemplateGroupId } = props

  const artworkTemplateGroupPayload = useArtworkTemplateGroup({ id: artworkTemplateGroupId })

  return (
    <PageLayout artworkTemplateGroupPayload={artworkTemplateGroupPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        <ArtworkTemplateGroupLinkLists
          filters={{
            artworkTemplateGroupId,
            entityTitle: 'Organisations',
            entityType: 'Client',
          }}
        />

        <ArtworkTemplateGroupLinkLists
          filters={{
            artworkTemplateGroupId,
            entityTitle: 'Products',
            entityType: 'Product',
          }}
        />
      </Columns.Main>

      <Columns.Sidebar>
        {/* <ClientTools clientPayload={clientPayload} /> */}
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent

